import { openBlock as t, createElementBlock as o, createElementVNode as n } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function l(m, e) {
  return t(), o("svg", r, [...e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      d: "M20 20H4V4h16zm-7.333-.667h6.666V12.33h-6.666zm-8 0H12V12.33H4.667zm8-7.67h6.666V4.667h-6.666zm-8 0H12V4.667H4.667z"
    }, null, -1)
  ])]);
}
const h = { render: l };
export {
  h as default,
  l as render
};
